import styled from 'styled-components';

export const Wrapper = styled.div`
	.Select-menu-outer {
		z-index: 999 !important;
	}
`;
